/**
 * In-job "More" page: card-style list of the setup/legacy tabs. Keeps the top
 * tab bar punchy without hiding anything.
 */
import { Link, useOutletContext } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { FileEdit, FilePlus2, ShieldAlert, ShieldPlus, FileText, Calendar, Wallet } from "lucide-react";

const ITEMS = [
  { to: "variations",   label: "Variations",        Icon: FileEdit,   testid: "more-variations",  mgmt: true },
  { to: "pos",          label: "Purchase Orders",   Icon: FilePlus2,  testid: "more-pos",         mgmt: true },
  { to: "hs",           label: "H&S",               Icon: ShieldAlert, testid: "more-hs" },
  { to: "hs-extras",    label: "H&S Extras",        Icon: ShieldPlus, testid: "more-hs-extras" },
  { to: "documents",    label: "Documents",         Icon: FileText,   testid: "more-docs" },
  { to: "programme",    label: "Programme",         Icon: Calendar,   testid: "more-programme",   mgmt: true },
  { to: "financials",   label: "Financials",        Icon: Wallet,     testid: "more-financials",  mgmt: true },
];

export default function ProjectMore() {
  const { project } = useOutletContext();
  const { user } = useAuth();
  const items = ITEMS.filter(it => !it.mgmt || user?.role !== "Worker");
  return (
    <div className="card !p-0 divide-y divide-neutral-900" data-testid="project-more">
      {items.map(it => (
        <Link key={it.to} to={`/projects/${project.id}/${it.to}`} data-testid={it.testid}
              className="flex items-center gap-3 px-4 py-3 hover:bg-neutral-900">
          <it.Icon size={18} className="text-silver"/>
          <span className="flex-1">{it.label}</span>
          <span className="opacity-50 text-xs">Open →</span>
        </Link>
      ))}
    </div>
  );
}
